module.exports = "<div class=\"wrapper\">\n    <div [id]=\"element\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/texteditor/texteditor.component.html
// module id = ./src/app/components/tools/texteditor/texteditor.component.html
// module chunks = main